export const addPrefixToUrl = (url: string): string => {
  if (['http://', 'https://'].some((prefix) => url.startsWith(prefix))) {
    return url;
  }
  return `//${url}`;
};

export const sanitizeTextInput = (text: string): string => {
  return text.replace(/ /g, '');
};

export const snakeToCamel = (str: string) =>
  str
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace('-', '').replace('_', ''),
    );
